import styles from "./ChangePassword.module.scss";
import { useHistory } from "react-router";
//ICO
import ArrowBack from "../../../../styles/icon/arrow_back_fill.svg";
import EyeIcon from "../../../../styles/icon/eyes.svg";
import PassVisibility from "../../../../helpers/PassVisibility";
export default function ChangePassword() {
  const history = useHistory();

  //
  const handleChangePassword = (e) => {
    e.preventDefault();
  };
  return (
    <div className={styles.container}>
      <div className={styles.backIcon}>
        <img
          src={ArrowBack}
          alt="BACK"
          width={15}
          height={15}
          onClick={() => history.goBack()}
          className="convertPicToWhite"
        />
      </div>
      <div className={`font_color_white ${styles.title_of_page}`}>
        تغییر رمز عبور
      </div>
      <form onSubmit={handleChangePassword}>
        <div className={styles.Inputs_container}>
          <div className={styles.one_input_container}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="password"
              placeholder="رمز عبور فعلی"
              id="userCurrentPassword"
            />
            <div className={styles.show_hidden_pass_container}>
              <img
                src={EyeIcon}
                alt="visibility"
                width={15}
                height={15}
                onClick={() => PassVisibility("userCurrentPassword")}
              />
            </div>
          </div>
          <div className={styles.one_input_container}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="password"
              placeholder="رمز عبور جدید"
              id="userNewPassword"
            />
            <div className={styles.show_hidden_pass_container}>
              <img
                src={EyeIcon}
                alt="visibility"
                width={15}
                height={15}
                onClick={() => PassVisibility("userNewPassword")}
              />
            </div>
          </div>
          <div className={styles.one_input_container}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="password"
              placeholder="تکرار رمز عبور جدید"
              id="repeatUserNewPassword"
            />
            <div className={styles.show_hidden_pass_container}>
              <img
                src={EyeIcon}
                alt="visibility"
                width={15}
                height={15}
                onClick={() => PassVisibility("repeatUserNewPassword")}
              />
            </div>
          </div>
          <button type="submit">ثبت</button>
        </div>
      </form>
    </div>
  );
}
